import styled from 'styled-components';
import { spacing } from 'ui/theme/utils';

export const TextArea = styled.textarea.attrs(({ rows = 5 }) => ({
  rows,
}))`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grey};
  box-shadow: ${({ boxShadow = 'bottom', variant, theme }) => {
    switch (variant) {
      case 'minimal':
        return theme.shadows.round;
      default:
        return theme.shadows[boxShadow] || boxShadow;
    }
  }};
  padding: ${({ variant }) => {
    switch (variant) {
      case 'minimal':
        return '11px';
      default:
        return '11px 11px 14px';
    }
  }};
  border-radius: 8px;
  border: none;
  width: 100%;
  text-align: left;
  letter-spacing: 0.62px;
  font-weight: 400;
  font-size: 13px;
  resize: ${({ resize = 'none' }) => resize};
  ${(props) => spacing(props)}

  &:active, &:focus, &:hover {
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
  }
`;
